/* global require*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyleSheet, } from 'react-native';
import { Card, CardItem, Text, Left, Right, View } from 'native-base';
import { Image } from 'react-native';

import { IMG } from '../constants';

class BlockResultBlock extends Component {
  handlerChange = (element) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      element,
      block
    });
  }

  render() {
    const { block } = this.props;

    return (
      <Card transparent>
        <Text style={styles.headerTitle}>{block.label}</Text>
        {block.elements.map((element, i) => {
          let color = '';
          let icon = '';

          if (+element.value >= 90) {
            color = 'red';
            icon = <Image source={IMG.Error} style={{ height: 44, width: 44 }} resizeMode="contain" />;
          } else if (+element.value > 30 && +element.value < 90) {
            color = 'orange';
            icon = <Image source={IMG.Warning} style={{ height: 50, width: 50 }} resizeMode="contain" />;
          } if (+element.value < 30) {
            color = 'green';
            icon = <Image source={IMG.Info} style={{ height: 44, width: 44 }} resizeMode="contain" />;
          }
          return <CardItem
            style={styles.item}
            key={i}
            onPress={() => this.handlerChange(element)}
          >
            <Left style={styles.left}>
              <View>{icon}</View>
              <Text style={styles.title}>{element.label}</Text>
            </Left>
            <Right >
              <Text style={{
                fontSize: 30,
                fontWeight: '700',
                color
              }}>{element.value}%</Text>
            </Right>
          </CardItem>;
        }
        )}</Card>
    );
  }
}

BlockResultBlock.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func
};

export default BlockResultBlock;

const styles = StyleSheet.create({
  item: {
    marginTop: 4,
    marginBottom: 5,
    // marginLeft: 5,
    // marginRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 0,
    paddingRight: 0,
    flex: 1
  },
  left: {
    flexGrow: 2,
    // fontWeight: '700'
  },
  headerTitle: {
    marginTop: 10,
    marginBottom: 5,
    // marginLeft: 5,
    // marginRight: 5,
    fontWeight: '700',
    color: "#0067a2"
  },
  title: {
    flexGrow: 1,
    paddingRight: 10,
    paddingLeft: 10
  },
  value: {
    fontSize: 30,
    fontWeight: '700'
  }
});